function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
define('TescoMobile_Catalog/js/view/contract-type-switcher',['uiComponent', 'ko', 'jquery', 'mage/translate', 'priceBox'], function (Component, ko, $, $t) {
  'use strict';

  return Component.extend({
    defaults: {
      meta: {},
      simFreeMeta: null,
      paygEnabled: false,
      simFreeEnabled: false,
      seoEnabled: false,
      basePaths: {}
    },
    initObservable: function () {
      this._super().observe(['contractType']);
      return this;
    },
    initialize: function () {
      this._super();
      const paygPDP = $('.categorypath-shop-pay-as-you-go').length;
      if (this.contractType() === 'payg' && this.paygEnabled) {
        this._enablePaygLayout();
      } else if (this.contractType() === 'simfree' && this.simFreeEnabled) {
        this._enableSimFreeLayout();
      } else {
        this._enablePaymLayout();
      }
      if (paygPDP || this._getUrlParam() === 'payg' && this.paygEnabled) {
        this.contractType('payg');
        this._enablePaygLayout();
        this._triggerProductTypeChange();
      } else if (this._getUrlParam() === 'simfree' && this.simFreeEnabled) {
        this.contractType('simfree');
        this._enableSimFreeLayout();
        this._triggerProductTypeChange();
      }
      $(document).on('tm:paygDeviceUnavailible', $.proxy(this.switchType, this));
      $(document).on('tm:paygActionBarReload', $.proxy(this._updateActionBarData, this));
    },
    _triggerProductTypeChange: function () {
      $(document).trigger('tm:onProductTypeChange');
    },
    switchType: function (type) {
      if (typeof type === 'string' && type) {
        this.contractType(type);
        if (type === 'payg') {
          this._enablePaygLayout();
          this._triggerProductTypeChange();
        } else if (type === 'simfree') {
          this._enableSimFreeLayout();
          this._triggerProductTypeChange();
        } else {
          this._enablePaymLayout();
        }
        this.setMeta(type);
      }
    },
    setMeta: function (contractType) {
      if (this.seoEnabled || !this.meta[contractType]) {
        return;
      }
      const meta = this.meta[contractType];
      for (let key in meta) {
        if (meta[key]) {
          $('meta[name="' + key + '"]').attr('content', meta[key]);
          if (key === 'title' && meta[key]) {
            $(document).prop('title', meta[key]);
          }
        }
      }
    },
    _enablePaygLayout: function () {
      $('.option-type-tariff').hide();
      $('.fieldset-tm-bundle-options').hide();
      $('.bundle-summary').hide();
      $('.dynamic-price-box').hide();
      $('.product-details > .box-tocart').hide();
      $('.action-bar__pdp-bundle-data').hide();
      $('.sim-free-add-to-cart-btn').hide();
      $('.payg-price-wrapper').show();
      $('.sim-free-wrapper').hide();
      $('.payg-add-to-cart-btn').show();
    },
    _enablePaymLayout: function () {
      $('.option-type-tariff').show();
      $('.fieldset-tm-bundle-options').show();
      $('.bundle-summary').show();
      $('.dynamic-price-box').show();
      $('.product-details > .box-tocart').show();
      $('.action-bar__pdp-bundle-data').show();
      $('.sim-free-add-to-cart-btn').hide();
      $('.payg-add-to-cart-btn').hide();
      $('.sim-free-add-to-cart-btn').hide();
      $('.payg-add-to-cart-btn').hide();
      $('.payg-price-wrapper').hide();
      $('.sim-free-wrapper').hide();
    },
    _enableSimFreeLayout: function () {
      $('.payg-add-to-cart-btn').hide();
      $('.option-type-tariff').hide();
      $('.fieldset-tm-bundle-options').hide();
      $('.bundle-summary').hide();
      $('.dynamic-price-box').hide();
      $('.product-details > .box-tocart').hide();
      $('.action-bar__pdp-bundle-data').hide();
      $('.payg-price-wrapper').hide();
      $('.sim-free-add-to-cart-btn').show();
      $('.sim-free-wrapper').show();
    },
    _getUrlParam: function () {
      const url = new URL(window.location);
      if (this.seoEnabled) {
        const contractType = Object.entries(this.basePaths).find(_ref => {
          let _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];
          return url.pathname.includes(value);
        });
        return contractType ? contractType[0] : null;
      } else {
        return url.searchParams.get('type') ? url.searchParams.get('type') : null;
      }
    },
    _updateActionBarData: function () {
      if (this.contractType() === 'payg') {
        this._enablePaygLayout();
        this._triggerProductTypeChange();
      } else if (this.contractType() === 'simfree') {
        this._enableSimFreeLayout();
        this._triggerProductTypeChange();
      } else {
        this._enablePaymLayout();
      }
    }
  });
});

